
import { Component, Prop, Vue } from 'bits/vue'

@Component({})
export default class OzIndeterminateSpinner extends Vue {
  $el!: HTMLDivElement

  /**
   * Size of the spinner in px
   */
  @Prop({
    type: Number,
    required: true,
    default: 20,
  })
  size!: number

  @Prop({ required: false, default: 'auto' }) darkMode!: true | false | 'auto'

  get spinnerStyles(): Record<string, string> {
    return {
      width: this.size + 'px',
      height: this.size + 'px',
    }
  }
}
